/* ==========================================================================
   PROMAX — theme behaviour
   No framework and no build step: one file, event delegation, and Shopify's
   own Cart AJAX API. Everything here degrades to working HTML if it fails.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.PROMAX || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------- money -- */
  function money(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  /* ------------------------------------------------------------- toast -- */
  var toastTimer;
  function toast(msg) {
    var el = $('.toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2400);
  }

  /* ======================================================= CART (AJAX) === */
  var Cart = {
    add: function (id, qty, props) {
      var body = { items: [{ id: Number(id), quantity: qty || 1 }] };
      if (props) body.items[0].properties = props;
      return fetch(T.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(readJSON);
    },
    change: function (key, qty) {
      return fetch(T.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(readJSON);
    },
    get: function () {
      return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(readJSON);
    }
  };

  function readJSON(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw new Error(data.description || data.message || T.strings.error);
      return data;
    });
  }

  /* Replace one region of the page with the same region from a fresh render.
     Anything that fails here must not swallow the add that already succeeded. */
  function swap(url, selector) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(selector);
        var here = $(selector);
        if (fresh && here) {
          here.innerHTML = fresh.innerHTML;
        } else if (window.console) {
          console.warn('[promax] could not refresh ' + selector + ' from ' + url);
        }
      })
      .catch(function () {});
  }

  /* Repaint everything that shows cart state. The drawer and the bag page are
     rendered by Liquid, so they are re-fetched rather than rebuilt in JS —
     one source of truth for the markup. */
  function refreshCart(openDrawer) {
    return Cart.get().then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      document.documentElement.style.setProperty('--cart-count', cart.item_count);

      var jobs = [];

      /* The drawer is a section, so Shopify can re-render just that piece. */
      if ($('[data-cart-drawer]')) {
        jobs.push(swap(T.routes.cart + '?section_id=cart-drawer', '[data-cart-drawer-inner]'));
      }
      /* The cart page's section lives inside a JSON template and is not
         addressable by file name, so the page itself is re-fetched. */
      if ($('[data-cart-page]')) {
        jobs.push(swap(T.routes.cart, '[data-cart-page-inner]'));
      }

      if (!jobs.length) {
        if (openDrawer) window.location.href = T.routes.cart;
        return cart;
      }
      return Promise.all(jobs).then(function () {
        if (openDrawer) openCart(true);
        return cart;
      });
    });
  }

  function openCart(state) {
    var wrap = $('[data-cart-drawer]');
    if (!wrap) return;
    var panel = wrap.querySelector('.drawer');
    var scrim = wrap.querySelector('.scrim');
    var on = state !== false;
    if (panel) panel.classList.toggle('is-on', on);
    if (scrim) scrim.classList.toggle('is-on', on);
    document.body.classList.toggle('no-scroll', on);
    if (on && panel) {
      var close = panel.querySelector('[data-cart-close]');
      if (close) close.focus();
    }
  }

  /* ==================================================== WISHLIST ========= */
  var Wish = {
    key: 'promax:wish',
    read: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
      this.paint();
    },
    has: function (h) { return this.read().indexOf(h) > -1; },
    toggle: function (h) {
      var l = this.read(), i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else l.push(h);
      this.write(l);
      return i === -1;
    },
    paint: function () {
      var l = this.read();
      $$('[data-wish]').forEach(function (b) {
        b.setAttribute('aria-pressed', l.indexOf(b.dataset.wish) > -1 ? 'true' : 'false');
      });
      $$('[data-wish-count]').forEach(function (el) {
        el.textContent = l.length;
        el.hidden = l.length === 0;
      });
    }
  };

  /* ====================================================== SLIDER ========= */
  /* Turns a filled element into a horizontal slider: swipe on a phone, arrows
     on a desktop that page by exactly one card and disable themselves at each
     end, so an arrow never promises a move it cannot make. */
  function slider(track, label) {
    if (!track || track.dataset.slider === 'on' || !track.children.length) return;
    track.dataset.slider = 'on';
    track.classList.add('slider__track');

    var wrap = document.createElement('div');
    wrap.className = 'slider';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    function arrow(dir, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'slider__nav slider__nav--' + dir;
      b.setAttribute('aria-label', (dir === 'prev' ? 'Previous ' : 'Next ') + (label || 'items'));
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"/></svg>';
      wrap.appendChild(b);
      return b;
    }
    var prev = arrow('prev', 'm15 5-7 7 7 7');
    var next = arrow('next', 'm9 5 7 7-7 7');

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var none = max < 4;
      prev.disabled = none || track.scrollLeft < 4;
      next.disabled = none || track.scrollLeft > max - 4;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step() });
      setTimeout(update, 80);
      setTimeout(update, 460);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* =============================================== FLAVOUR SLIDER ======== */
  /* The chips across the bottom of a line's hero. Swapping a flavour repaints
     the band from data already in the DOM — no request, no flash. */
  function flavourWall(root) {
    var chips = $$('[data-fw-chip]', root);
    if (!chips.length) return;
    var panes = $$('[data-fw-pane]', root);

    function show(index) {
      chips.forEach(function (c, i) { c.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      panes.forEach(function (p, i) { p.hidden = i !== index; });
      var pane = panes[index];
      if (pane && pane.dataset.ground) {
        root.style.setProperty('--c', pane.dataset.ground);
        root.style.setProperty('--cc', pane.dataset.ink);
      }
      var chip = chips[index];
      if (chip && chip.parentNode.scrollWidth > chip.parentNode.clientWidth) {
        chip.parentNode.scrollTo({ left: chip.offsetLeft - 20, behavior: 'smooth' });
      }
    }
    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { show(i); });
      c.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + chips.length) % chips.length;
        chips[n].focus();
        show(n);
      });
    });
    show(0);
  }

  /* ================================================ VARIANT PICKER ======= */
  function variantPicker(form) {
    var data = $('[data-variants]', form);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-price]', form.closest('[data-product]') || document);
    var addBtn = $('[data-add-to-cart]', form);

    function selected() {
      return $$('[data-opt]', form).map(function (group) {
        var on = group.querySelector('[aria-pressed="true"], option:checked, input:checked');
        return on ? (on.value || on.dataset.value) : null;
      });
    }
    function apply() {
      var picked = selected();
      var match = variants.filter(function (v) {
        return picked.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      form.dataset.unitPrice = match.price;
      if (priceEl) priceEl.innerHTML = money(match.price);
      form.dispatchEvent(new CustomEvent('promax:variant', { detail: match }));
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.dataset.soldOut = match.available ? '' : 'true';
      }
      if (history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.pill-opt');
      if (!b || b.disabled) return;
      $$('.pill-opt', b.closest('[data-opt]')).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      apply();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('select, input[type=radio]')) apply();
    });
  }

  /* ============================================ PREDICTIVE SEARCH ======== */
  function predictive() {
    var bar = $('[data-searchbar]');
    if (!bar) return;
    var input = $('input[name="q"]', bar);
    var out = $('[data-psearch]', bar);
    if (!input || !out || !T.predictiveSearch) return;
    var timer, controller;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = T.routes.predictive_search + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('[data-psearch-results]');
            out.innerHTML = res ? res.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }

  function openSearch(state) {
    var bar = $('[data-searchbar]');
    if (!bar) return;
    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.toggle('is-on', state !== false); });
    document.body.classList.toggle('no-scroll', state !== false);
    if (state === false) setTimeout(function () { bar.hidden = true; }, 260);
    else { var i = $('input[name="q"]', bar); if (i) i.focus(); }
  }

  /* ================================================= SCROLL REVEAL ======= */
  function reveal() {
    if (!document.body.classList.contains('reveal-on')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  }


  /* ================================================== RECENTLY VIEWED ==== */
  /* Kept in the visitor's own browser, newest first, capped so the list stays
     a short memory rather than a history. */
  var Recent = {
    key: 'promax:recent',
    max: 12,
    read: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    push: function (handle) {
      if (!handle) return;
      var l = this.read().filter(function (h) { return h !== handle; });
      l.unshift(handle);
      try { localStorage.setItem(this.key, JSON.stringify(l.slice(0, this.max))); } catch (e) {}
    },
    paint: function () {
      var section = $('[data-recent-section]');
      var grid = $('[data-recent-grid]');
      if (!section || !grid) return;
      var seen = this.read();
      var here = document.body.dataset.productHandle;
      var shown = 0;
      $$('[data-recent-item]', grid).forEach(function (el) {
        var handle = el.dataset.recentItem;
        var on = seen.indexOf(handle) > -1 && handle !== here;
        el.hidden = !on;
        if (on) shown++;
      });
      /* order the visible ones the way they were seen */
      seen.slice().reverse().forEach(function (handle) {
        var el = grid.querySelector('[data-recent-item="' + CSS.escape(handle) + '"]');
        if (el && !el.hidden) grid.insertBefore(el, grid.firstChild);
      });
      section.hidden = shown === 0;
    }
  };

  /* ========================================================== POPUP ====== */
  function popup() {
    var el = $('[data-popup]');
    if (!el) return;
    var key = el.dataset.key || 'promax:popup';
    var days = Number(el.dataset.days || 14);
    var delay = Number(el.dataset.delay || 8) * 1000;

    var until = 0;
    try { until = Number(localStorage.getItem(key)) || 0; } catch (e) {}
    if (Date.now() < until) return;

    function dismiss() {
      el.classList.remove('is-on');
      setTimeout(function () { el.hidden = true; }, 260);
      try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch (e) {}
      document.body.classList.remove('no-scroll');
    }

    setTimeout(function () {
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-on'); });
      var first = el.querySelector('input, button');
      if (first) first.focus();
    }, delay);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); dismiss(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hidden) dismiss();
    });
  }

  /* ======================================================= COUNTDOWN ===== */
  function countdown(root) {
    var until = Date.parse((root.dataset.until || '').replace(' ', 'T'));
    if (isNaN(until)) return;
    var clock = $('[data-countdown-clock]', root);
    var done = $('[data-countdown-done]', root);
    var cells = {};
    $$('[data-cd]', root).forEach(function (el) { cells[el.dataset.cd] = el; });

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = until - Date.now();
      if (left <= 0) {
        if (clock) clock.hidden = true;
        if (done) done.hidden = false;
        clearInterval(timer);
        return;
      }
      var sec = Math.floor(left / 1000);
      if (cells.days) cells.days.textContent = Math.floor(sec / 86400);
      if (cells.hours) cells.hours.textContent = pad(Math.floor(sec / 3600) % 24);
      if (cells.minutes) cells.minutes.textContent = pad(Math.floor(sec / 60) % 60);
      if (cells.seconds) cells.seconds.textContent = pad(sec % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ======================================================= BACK TO TOP === */
  function backToTop() {
    var btn = $('[data-to-top]');
    if (!btn) return;
    function check() { btn.hidden = window.scrollY < window.innerHeight; }
    window.addEventListener('scroll', check, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    check();
  }


  /* =========================================================== REELS ===== */
  function reels(root) {
    var films = $$('[data-reel-video]', root);
    if (!films.length) return;

    var advance = root.dataset.advance !== 'false';
    var autoplay = root.dataset.autoplay !== 'false';
    var wantSound = false;
    var started = false;

    function tile(v) { return v.closest('[data-reel]'); }

    function mark(v, on) {
      var t = tile(v);
      if (t) t.classList.toggle('is-playing', on);
    }

    function play(v) {
      if (!v) return;
      films.forEach(function (other) {
        if (other === v) return;
        other.pause();
        other.currentTime = 0;
        mark(other, false);
      });
      v.muted = !wantSound;
      var p = v.play();
      if (p && p.catch) p.catch(function () { mark(v, false); });
    }

    films.forEach(function (v, i) {
      v.addEventListener('play', function () { mark(v, true); });
      v.addEventListener('pause', function () { mark(v, false); });
      v.addEventListener('ended', function () {
        mark(v, false);
        v.currentTime = 0;
        if (advance) play(films[i + 1]);
      });
      v.addEventListener('timeupdate', function () {
        var bar = $('[data-reel-bar] i', tile(v));
        if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
      });
    });

    /* one handler for the whole wall: tap a film to play it, tap it again to stop */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-reel-ig]')) return;      /* the corner mark opens the post */
      var t = e.target.closest('[data-reel]');
      if (!t) return;
      var v = $('[data-reel-video]', t);
      if (!v) return;
      e.preventDefault();
      if (v.paused) play(v); else v.pause();
    });

    /* arrive, and it starts itself; leave, and it stops */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (autoplay && !started) { started = true; play(films[0]); }
          } else {
            films.forEach(function (v) { v.pause(); });
          }
        });
      }, { threshold: 0.45 }).observe(root);
    }

    /* sound, for the one playing now and every one after it */
    var sound = $('[data-reels-sound]', root.closest('section') || root.parentNode);
    if (sound) {
      sound.addEventListener('click', function () {
        wantSound = !wantSound;
        sound.setAttribute('aria-pressed', wantSound ? 'true' : 'false');
        var label = $('[data-reels-sound-label]', sound);
        if (label) {
          label.textContent = wantSound ? sound.dataset.labelOn : sound.dataset.labelOff;
        }
        films.forEach(function (v) { if (!v.paused) v.muted = !wantSound; });
      });
    }
  }


  /* ================================================ QUICK QUANTITIES ===== */
  /* The buttons set a number. Every price still comes from Shopify — the line
     underneath only multiplies what the page was already told. */
  function qtyPresets(form) {
    var input = $('[name="quantity"]', form);
    if (!input) return;
    var chips = $$('[data-qty-set]', form);
    var scope = form.closest('[data-product]') || document;
    var sum = $('[data-qty-sum]', scope);

    function unit() { return Number(form.dataset.unitPrice || 0); }

    function paint() {
      var q = Math.max(1, parseInt(input.value, 10) || 1);
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', Number(c.dataset.qtySet) === q ? 'true' : 'false');
      });
      if (!sum) return;
      if (q > 1 && unit() > 0) {
        sum.textContent = q + ' × ' + money(unit()) + ' = ' + money(unit() * q);
        sum.hidden = false;
      } else {
        sum.hidden = true;
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        input.value = c.dataset.qtySet;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('input', paint);
    input.addEventListener('change', paint);
    form.addEventListener('promax:variant', paint);
    paint();
  }


  /* ================================================ STICKY OFFSETS ======= */
  /* The mobile bar and the buy bar stack. Their heights depend on the font,
     the labels and the device's safe area, so they are measured, not guessed —
     everything that has to clear them reads these two numbers. */
  function stickyOffsets() {
    var root = document.documentElement;

    function measure() {
      var bar = $('.mbar');
      var buy = $('[data-buyzone]');
      var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      var b = buy && getComputedStyle(buy).position === 'fixed'
        ? Math.round(buy.getBoundingClientRect().height) : 0;
      root.style.setProperty('--mbar-h', h + 'px');
      root.style.setProperty('--buyzone-h', b + 'px');
    }

    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('orientationchange', measure);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ['.mbar', '[data-buyzone]'].forEach(function (sel) {
        var el = $(sel);
        if (el) ro.observe(el);
      });
    }
    return measure;
  }


  /* ============================================================ MENU ===== */
  function menuIsOpen() {
    var nav = $('[data-mobile-nav]');
    return !!nav && nav.classList.contains('is-on');
  }

  function openMenu(on) {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    var veil = $('[data-menu-veil]');
    /* the stylesheet drives the drawer with .is-on, so `hidden` is only the
       no-JS default and has to come off before anything can slide */
    nav.hidden = false;
    nav.classList.toggle('is-on', on);
    if (veil) veil.classList.toggle('is-on', on);
    document.body.classList.toggle('no-scroll', on);
    $$('[data-menu-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (on) {
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }
  }

  /* a swipe back towards the edge it came from */
  function menuSwipe() {
    var nav = $('[data-mobile-nav]');
    if (!nav || nav.dataset.swipeBound) return;
    nav.dataset.swipeBound = '1';
    var x0 = 0, y0 = 0, tracking = false;

    nav.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    nav.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      /* sideways, and clearly so — otherwise this fights scrolling */
      if (dx < -55 && Math.abs(dx) > Math.abs(dy) * 1.6) {
        tracking = false;
        openMenu(false);
      }
    }, { passive: true });

    nav.addEventListener('touchend', function () { tracking = false; }, { passive: true });
  }


  /* ====================================================== HERO FILM ====== */
  /* The markup carries no autoplay and preloads nothing, so a phone spends no
     data on the film until someone asks for it. A wide screen starts it here —
     and not at all for a reader who has asked for less motion. */
  function heroVideo(video) {
    var wrap = video.closest('.vhero__stage') || video.parentNode;
    var button = $('[data-hero-play]', wrap);
    var wide = window.matchMedia('(min-width: 901px)').matches;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mark() { wrap.classList.toggle('is-playing', !video.paused); }

    function start() {
      video.preload = 'auto';
      var p = video.play();
      if (p && p.catch) p.catch(function () { mark(); });
    }

    video.addEventListener('play', mark);
    video.addEventListener('pause', mark);

    if (button) {
      button.addEventListener('click', function () {
        if (video.paused) start(); else video.pause();
      });
    }

    if (wide && !still) start();
    mark();
  }

  /* ==================================================== DELEGATION ======= */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-add-to-cart]'))) {
      var form = el.closest('form');
      if (!form) return;
      e.preventDefault();
      var id = $('[name="id"]', form).value;
      var qtyField = $('[name="quantity"]', form);
      el.classList.add('is-busy');
      Cart.add(id, qtyField ? Number(qtyField.value) : 1)
        .then(function () { return refreshCart(T.cartType === 'drawer'); })
        .then(function () { toast(T.strings.added); })
        .catch(function (err) { toast(err.message || T.strings.error); })
        .then(function () { el.classList.remove('is-busy'); });
      return;
    }

    if ((el = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      if (!el.dataset.quickAdd) { toast(T.strings.soon); return; }
      el.classList.add('is-busy');
      Cart.add(el.dataset.quickAdd, 1)
        .then(function () { return refreshCart(T.cartType === 'drawer'); })
        .then(function () { toast(T.strings.added); })
        .catch(function (err) { toast(err.message || T.strings.error); })
        .then(function () { el.classList.remove('is-busy'); });
      return;
    }

    if ((el = e.target.closest('[data-line-change]'))) {
      e.preventDefault();
      var row = el.closest('[data-line]');
      Cart.change(row.dataset.line, Number(el.dataset.lineChange))
        .then(function () { return refreshCart(false); })
        .catch(function (err) { toast(err.message || T.strings.error); });
      return;
    }

    if ((el = e.target.closest('[data-wish]'))) {
      e.preventDefault();
      var added = Wish.toggle(el.dataset.wish);
      toast(added ? T.strings.saved : T.strings.removed);
      if (document.body.classList.contains('template-page') && $('[data-wishlist-grid]')) paintWishlistPage();
      return;
    }

    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-veil]')) { e.preventDefault(); openCart(false); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(true); return; }
    if (e.target.closest('[data-search-close]') || e.target.closest('[data-search-veil]')) { e.preventDefault(); openSearch(false); return; }

    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      openMenu(!menuIsOpen());
      return;
    }
    if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-veil]')) {
      e.preventDefault();
      openMenu(false);
      return;
    }

    if ((el = e.target.closest('[data-acc-q]'))) {
      var open = el.getAttribute('aria-expanded') === 'true';
      el.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = document.getElementById(el.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) {
      var row = input.closest('[data-line]');
      Cart.change(row.dataset.line, Number(input.value))
        .then(function () { return refreshCart(false); })
        .catch(function (err) { toast(err.message || T.strings.error); });
    }
    var facet = e.target.closest('[data-facet-form]');
    if (facet) facet.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openCart(false);
    openSearch(false);
    openMenu(false);
  });

  /* ------------------------------------------------ wishlist page ------- */
  function paintWishlistPage() {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var saved = Wish.read();
    var empty = $('[data-wishlist-empty]');
    var any = false;
    $$('[data-wishlist-item]', grid).forEach(function (card) {
      var on = saved.indexOf(card.dataset.wishlistItem) > -1;
      card.hidden = !on;
      if (on) any = true;
    });
    if (empty) empty.hidden = any;
    grid.hidden = !any;
  }

  /* ---------------------------------------------------------- quantity -- */
  document.addEventListener('click', function (e) {
    /* only the product form's stepper — a cart line drives itself through
       data-line-change, and must not also be nudged from here */
    var b = e.target.closest('.qty button[data-step]');
    if (!b) return;
    e.preventDefault();
    var input = $('input', b.parentNode);
    var next = Number(input.value || 1) + (b.dataset.step === 'up' ? 1 : -1);
    input.value = Math.max(Number(input.min || 1), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================= BOOT === */
  function boot(scope) {
    scope = scope || document;
    $$('[data-slider]', scope).forEach(function (t) { slider(t, t.dataset.slider); });
    $$('[data-flavour-wall]', scope).forEach(flavourWall);
    $$('[data-reels]', scope).forEach(reels);
    $$('[data-hero-video]', scope).forEach(heroVideo);
    menuSwipe();
    $$('[data-product-form]', scope).forEach(variantPicker);
    $$('.pdp__form', scope).forEach(qtyPresets);
    if (!window.PROMAX.measureBars) window.PROMAX.measureBars = stickyOffsets();
    else window.PROMAX.measureBars();
    Wish.paint();
    paintWishlistPage();
    predictive();
    reveal();
    popup();
    backToTop();
    $$('[data-countdown]', scope).forEach(countdown);

    /* remember this product, then repaint the row that shows them */
    var handle = document.body.dataset.productHandle;
    if (handle) Recent.push(handle);
    Recent.paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* The theme editor swaps section markup in and out; rebind what it replaces. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.PROMAX.cart = Cart;
  window.PROMAX.refreshCart = refreshCart;
  window.PROMAX.toast = toast;
  window.PROMAX.slider = slider;
  window.PROMAX.money = money;
  window.PROMAX.wishlist = Wish;
  window.PROMAX.recent = Recent;
})();
